import { apiClient } from "../api/apiclient"


export const CreateCategoryType = (categoryType, token) =>
    apiClient.post(
        "/category-type",
        categoryType,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );

export const getAllCategoryType = (token) =>
    apiClient.get("/category-types", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const UpdateCategoryType = (id, token, updateCategoryType) =>
    apiClient.put(`/category-type/${id}`, updateCategoryType,{
        headers: { Authorization: `Bearer ${token}` },
    });